export default __webpack_public_path__ + "static/media/aquasil-ultra-take-1.0dbe2aea.png";